import React from 'react';
import { Flex } from '@balance-web/flex';

import {
  AppleIcon,
  GoogleIcon,
  MicrosoftIcon,
} from './singleSignOnButton/Icons';
import { SingleSignOnButton } from './singleSignOnButton';

export type SingleSignOnButtonsProps = {
  microsoft?: { onClick: () => void };
  google?: { onClick: () => void };
  apple?: { onClick: () => void };
};

export const SingleSignOnButtons = ({
  microsoft,
  google,
  apple,
}: SingleSignOnButtonsProps) => {
  return (
    <Flex direction="column" gap="small">
      {google && (
        <SingleSignOnButton
          icon={<GoogleIcon />}
          label="Continue with Google"
          onClick={google.onClick}
        />
      )}

      {microsoft && (
        <SingleSignOnButton
          icon={<MicrosoftIcon />}
          label="Continue with Microsoft"
          onClick={microsoft.onClick}
        />
      )}

      {apple && (
        <SingleSignOnButton
          icon={<AppleIcon />}
          label="Continue with Apple"
          onClick={apple.onClick}
        />
      )}
    </Flex>
  );
};
